import React, { useCallback } from 'react'
import { BlockNoteView } from '@blocknote/mantine'
import '@blocknote/mantine/style.css'
import '@blocknote/core/fonts/inter.css'
import { Box } from '@mui/material'
import BlockNoteHeader, { MENU_BACKGROUND_COLOR } from './BlockNoteHeader'

const BlockNote = (props) => {
  const { editor, readOnly } = props

  const handleKeyDownCapture = useCallback((event) => {
    if (readOnly || !editor || event.key !== 'Delete') {
      return
    }

    const { selection } = editor.prosemirrorState

    if (!selection.empty) {
      return
    }

    const isAtEndOfBlock = selection.$from.parentOffset === selection.$from.parent.content.size

    if (!isAtEndOfBlock) {
      return
    }

    const cursorPosition = editor.getTextCursorPosition()
    const isLastTopLevelBlock = !cursorPosition.nextBlock && !cursorPosition.parentBlock

    if (isLastTopLevelBlock) {
      event.preventDefault()
      event.stopPropagation()
    }
  }, [editor, readOnly])

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        flexDirection: 'column',

        '& .bn-container': {
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column-reverse'
        },
        '& .bn-editor': {
          flexGrow: 1,
          textAlign: 'left',
          padding: '24px 50px',
          width: '100%',
          overflowY: 'auto',
          overflowX: 'hidden',
          minHeight: 0,
          boxSizing: 'border-box',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0
        },
        '& .bn-mantine .bn-toolbar': {
          backgroundColor: 'transparent', border: 'initial', boxShadow: 'initial'
        },
        '& .bn-mantine .bn-toolbar .bn-formatting-toolbar': {
          width: '100%'
        },
        '& .bn-mantine .bn-toolbar .bn-button': {
          backgroundColor: MENU_BACKGROUND_COLOR
        }
      }}
    >
      <BlockNoteView
        editor={editor}
        theme='dark'
        formattingToolbar={false}
        editable={!readOnly}
        onKeyDownCapture={handleKeyDownCapture}
      >
        {!readOnly && <BlockNoteHeader editor={editor} />}
      </BlockNoteView>
    </Box>
  )
}

export default BlockNote
